"use strict";

const SamplingSiteInventoryData = function () {
  var getProps = function () {
    return {};
  };

  // Maps an offline GeoServer sampling site row onto the shared `assetInfo` shape.
  // Mirrors api/app/Wq/SamplingSite.php `name` and `assetDisplayType` attributes.
  var mapAssetToAssetInfo = function (samplingSite) {
    return {
      id: samplingSite.id,
      name: samplingSite.siteName ?? samplingSite.siteIdentifier,
      assetType: "sampling-site",
      assetDisplayType: ToolSettings.getSetting("constants", "assetDisplayNames", "sampling-site"),
      lastInspectionDisplayDate: samplingSite.lastInspectionDisplayDate,
      activeMaintenanceIssues: [],
      inventoryData: {},
    };
  };

  return {
    getProps,
    mapAssetToAssetInfo,
  };
};

module.exports = SamplingSiteInventoryData();

const ToolSettings = require("../../../settings/toolSettings");
